import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Tour, Button, Message} from 'kpc';

var _$tmp0 = {
    'style': 'margin-left: 10px;'
};
var _$tmp1 = {
    'style': 'margin-top: 20px;'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'id': 'event-btn1',
                'children': '第一步'
            }),
            _$cc(Button, {
                'id': 'event-btn2',
                'style': 'margin-left: 20px;',
                'children': '第二步'
            }),
            _$cc(Button, {
                'id': 'event-btn3',
                'style': 'margin-left: 20px;',
                'children': '第三步'
            })
        ], 4, 'example-container'),
        _$cc(Tour, {
            'visible': this.get('showTour'),
            'data': this.get('tourData'),
            'ev-prev': this.handlePrev,
            'ev-next': this.handleNext,
            'ev-finish': this.handleFinish,
            'ev-$model:value': function($v) {
                $this.set('currentStep', $v);
            },
            'value': $this.get('currentStep')
        }),
        _$ce(2, 'div', [
            _$cc(Button, {
                'ev-click': this.startTour,
                'children': '\n            开始引导\n        '
            }),
            _$ce(2, 'span', [
                _$ct('\n            当前步骤: '),
                this.get('currentStep') >= 0 ? this.get('currentStep') + 1 : '未启动'
            ], 0, null, _$tmp0)
        ], 4, null, _$tmp1)
    ], 4);
};